import { ProductConsultDto } from './product-consult.dto';

export class ProductConsultUpdateDto extends ProductConsultDto {}
